module.exports = __webpack_public_path__ + "static/img/reportInfo.2f71cdc7.png";